var map = {
	"./arcade.jpg": "j+nv",
	"./argyle.jpg": "tOuW",
	"./cars.jpg": "uPlg",
	"./castle.jpg": "dd7b",
	"./egypt.jpg": "R0mW",
	"./honey.jpg": "c5lJ",
	"./marble.jpg": "A7sL",
	"./redbrick.jpg": "ceAV",
	"./rivets.jpg": "yIja",
	"./squares.jpg": "dlEa",
	"./thatch.jpg": "Qu4m",
	"./winlogo.jpg": "MF2W",
	"./winlogo_large.jpg": "nJOK",
	"./zigzag.jpg": "GNvw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6M0X";